import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledCloseButtonWrapper = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;

  ${themeMedia.tablet`
    top: 1rem;
    right: 1rem;
  `};
`

export const StyledIframeWrapper = styled.div`
  padding-top: 40px;
  width: 100%;
  height: calc(100% - 40px);

  ${themeMedia.tablet`
    padding: 0;
    height: 100%;
  `};

  iframe {
    width: 100%;
    height: 100%;
  }
`
